<div class="logged-in-view h-full overflow-y-auto">
    <div class="w-full">
        <h1 class="text-app-primary-10 mb-18">Terminübersicht</h1>

        <div class="grid grid-cols-1 lg:grid-cols-12 gap-8">
            <!-- Linke Spalte: Terminübersicht -->
            <div class="lg:col-span-4 flex flex-col gap-6">
                <div class="card bg-app-background-10 rounded-button p-6 shadow-sm border border-app-primary-10/5">
                    <div class="text-2xl font-semibold text-app-primary-10 mb-6">Terminübersicht –</div>

                    <div class="flex flex-col gap-8">
                        <!-- Heute -->
                        <section>
                            <div class="text-lg font-bold text-app-primary-10 mb-4">Heute</div>
                            <div class="flex flex-col gap-3">
                                @for (appointment of todayAppointments; track appointment.id) {
                                    <div
                                        (click)="toPatientFile(appointment)"
                                        class="flex items-center justify-between p-4 bg-app-background-20 rounded-lg border border-app-primary-10/5 hover:border-app-primary-10/20 cursor-pointer transition-colors">
                                        <div class="flex flex-col">
                                            <span class="text-sm font-bold text-app-primary-10 mb-1">
                                                {{ appointment.from | date: 'dd.MM.yyyy – HH:mm' }} Uhr
                                            </span>
                                            <div class="flex items-center gap-2 text-app-primary-10/70">
                                                <div class="w-6 h-6 rounded-md bg-app-primary-10/10 flex items-center justify-center">
                                                    <i class="fa-regular fa-clipboard text-[10px] text-app-primary-10"></i>
                                                </div>
                                                <span class="text-sm font-medium">{{ appointment.patient.firstName }} {{ appointment.patient.lastName }}</span>
                                            </div>
                                        </div>
                                    </div>
                                } @empty {
                                    <p class="text-sm text-app-primary-10/50 italic">Keine Termine für heute</p>
                                }
                            </div>
                        </section>

                        <!-- Diese Woche -->
                        <section>
                            <div class="text-lg font-bold text-app-primary-10 mb-4">Diese Woche</div>
                            <div class="flex flex-col gap-3">
                                @for (appointment of thisWeekAppointments; track appointment.id) {
                                    <div
                                        (click)="toPatientFile(appointment)"
                                        class="flex items-center justify-between p-4 bg-gray-100/50 rounded-lg border border-transparent hover:border-app-primary-10/20 cursor-pointer transition-colors">
                                        <div class="flex flex-col">
                                            <span class="text-sm font-bold text-app-primary-10/60 mb-1">
                                                {{ appointment.from | date: 'dd.MM.yyyy – HH:mm' }} Uhr
                                            </span>
                                            <span class="text-sm text-app-primary-10/50">{{ appointment.patient.firstName }} {{ appointment.patient.lastName }}</span>
                                        </div>
                                    </div>
                                } @empty {
                                    <p class="text-sm text-app-primary-10/50 italic">Keine weiteren Termine diese Woche</p>
                                }
                            </div>
                        </section>

                        <!-- Nächste Woche -->
                        <section>
                            <div class="text-lg font-bold text-app-primary-10 mb-4">Nächste Woche</div>
                            <div class="flex flex-col gap-3">
                                @for (appointment of nextWeekAppointments; track appointment.id) {
                                    <div
                                        (click)="toPatientFile(appointment)"
                                        class="flex items-center justify-between p-4 bg-gray-100/50 rounded-lg border border-transparent hover:border-app-primary-10/20 cursor-pointer transition-colors">
                                        <div class="flex flex-col">
                                            <span class="text-sm font-bold text-app-primary-10/60 mb-1">
                                                {{ appointment.from | date: 'dd.MM.yyyy – HH:mm' }} Uhr
                                            </span>
                                            <span class="text-sm text-app-primary-10/50">{{ appointment.patient.firstName }} {{ appointment.patient.lastName }}</span>
                                        </div>
                                    </div>
                                } @empty {
                                    <p class="text-sm text-app-primary-10/50 italic">Keine Termine nächste Woche</p>
                                }
                            </div>
                        </section>
                    </div>
                </div>
            </div>

            <!-- Rechte Spalte: Kalender -->
            <div class="lg:col-span-8">
                <div class="card bg-white rounded-lg p-6 shadow-sm border border-app-primary-10/5 h-full">
                    <div class="calendar-container h-full">
                        @if (doctor && doctor.calendarOptions && doctor.mappedAppointments) {
                            <full-calendar #calendar [options]="doctor.calendarOptions"
                                           [events]="doctor.mappedAppointments">
                            </full-calendar>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
